import { IconList16, Spinner } from '@cian/ui-kit';
import cx from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { ControlLinkButton } from '../../ControlLinkButton';

interface IListingButtonProps {
  url: string;
  onClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void;
  loading?: boolean;
}

export function ListingButton({ url, onClick, loading }: IListingButtonProps) {
  return (
    <ControlLinkButton href={url} className={cx(styles['navigation-btn'], styles['listing-btn'])} onClick={onClick}>
      {loading ? (
        <div className={styles['loader']}>
          <Spinner size={16} color="primary_100" display="inline-block" />
        </div>
      ) : (
        <>
          <IconList16 color="black_100" />
          <span className={styles['listing-title']}>Списком</span>
        </>
      )}
    </ControlLinkButton>
  );
}
